import { confirmAlert, ReactConfirmAlertProps } from 'react-confirm-alert'
import './style.css'

export function confirm(options: ReactConfirmAlertProps): void {
    return confirmAlert(options)
}